// extracted by mini-css-extract-plugin
module.exports = {"paymentTab":"paymentTab_paymentTab__18sSb","paymentTabContents":"paymentTab_paymentTabContents__1aIEH","card":"paymentTab_card__2xtV9"};